__turbopack_context__.v({
  "accordion": "Accordion-module-scss-module__pVKnzq__accordion",
  "content": "Accordion-module-scss-module__pVKnzq__content",
  "fade-in": "Accordion-module-scss-module__pVKnzq__fade-in",
  "icon": "Accordion-module-scss-module__pVKnzq__icon",
  "no-transform": "Accordion-module-scss-module__pVKnzq__no-transform",
  "rotate": "Accordion-module-scss-module__pVKnzq__rotate",
  "summary": "Accordion-module-scss-module__pVKnzq__summary",
});
